import Vuex from 'vuex';
import Vue from 'vue';
import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
  loading: false,
  cart: [],
  order: {
    id: null,
    code: null,
    email: null,
  },
  items: [],
  item_next_page_url: 'http://admin.harigu.com/api/items?page=1',
  messages: [],
  colors: [],
  pagePositions: [],
  selectedColor: null,
  price: null,
  favorites: localStorage.getItem('favorites') ? JSON.parse(localStorage.getItem('favorites')) : [],
  atLogin: null
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: debug,
  plugins: [createPersistedState()]
});
